/* global globalThis */
import React, { useEffect, useState } from 'react';
import { makeStyles, Box, LinearProgress, Typography, Link } from '@material-ui/core';
import '../CoursesList/coursesList.scss';
import { useTranslations } from "sdk/custom-hooks";
import { useHistory } from "react-router-dom";
import { useDispatch, useSelector } from 'react-redux';
import { addCourse } from 'sdk/actions/addCourse';
import { reactGaEvent } from "sdk/actions/Common";
import PropTypes from 'prop-types';
import { ReactComponent as Live } from "../../../src/assets/images/live.svg";
import { ReactComponent as SuccessIcon } from "../../../src/assets/images/enrolledIcon.svg";
import { recentCourseAction } from 'sdk/actions';
import { courseAddedNotification } from 'sdk/actions/getNotifications';
import OverlayButton from '../../constants/OverlayButton';
import CommonButton from '../../constants/CommonButton';
import { useTheme } from '../../constants/themeProvider';
import { ReactComponent as ExpiringClock } from "../../../src/assets/images/expiringclock.svg";
import { ReactComponent as PointsIcon } from "../../../src/assets/images/points.svg";
import DefaultCourseImage from "../../../src/assets/images/course-image.jpg"
import { setCourseId, setCourseName, setCourseProgress } from 'sdk/actions/getCourses';
import { ReactComponent as CertifiedIcon } from "../../../src/assets/images/certifiedIcon.svg";
import moment from 'moment';
import { useLocation } from 'react-router-dom/cjs/react-router-dom';
import { ReactComponent as GreenTick } from "../../assets/images/greenTick.svg";
import { ReactComponent as StarVector1 } from "../../../src/assets/images/star-vector1.svg";
import { ReactComponent as StarVector2 } from "../../../src/assets/images/star-vector2.svg";
import { ReactComponent as StarVector3 } from "../../../src/assets/images/star-vector3.svg";

function EnrolledModal({ showModal, closeModal, classes, t, testData, history, showEvaluationTest, showInstructions }) {
    const handleStartCourse = () => {
        history.push(`/course/${testData?._id}`, {
            courseId: testData?._id,
            subjectId: '',
            topicId: '',
            subjectDetail: testData,
            testData: '',
            subjectName: '',
            topicName: '',
            courseName: testData?.name,
            courseProgress: testData?.progressPercent,
            showEvaluationTest,
            showInstructions
        });
    };

    return (
        <Box className={classes.modalBg + ` ${showModal ? 'show' : ''}`} onClick={closeModal}>
            <Box className={classes.modalContent} onClick={(e) => e.stopPropagation()}>
                <Box className={classes.modalContainer}>
                    <SuccessIcon className={classes.successIcon} />
                    <Box className={classes.starVectorBox}>
                        <StarVector1 className={classes.starVector1}/>
                        <StarVector2 className={classes.starVector2}/>
                        <StarVector3 className={classes.starVector3}/>
                    </Box>
                    <Typography variant="h2" className={classes.modalHeading}>
                        {t('You are Enrolled')}
                    </Typography>
                    <Typography variant="inherit" className={classes.modalSubtext}>
                        {t('You have successfully joined')} <strong>{testData?.name}.</strong> {t('Start your learning journey now')}
                    </Typography>
                    <CommonButton classStyleHeading={classes.okBtn} title={t("Start Course")} onClick={handleStartCourse} />
                    <Link
                        component="button"
                        underline="none"
                        className={classes.goToCoursesLink}
                        onClick={() => history.push('/my-courses', { params: globalThis.location.pathname })}
                    >
                        {t('Go to My Courses')}
                    </Link>
                </Box>
            </Box>
        </Box>
    );
}

function ExpirationBadge({ showComponent, expireDays, courseCompletedOn, certificateData, testData, courseExpiryDate, t }) {
    const isCompleted = expireDays > 0 && Boolean(courseCompletedOn);
    const width = certificateData?.courseId?._id === testData?._id ? '15vw' : '30vw';

    let expiryLabel = t('Expired');
    if (expireDays > 0) {
        expiryLabel = isCompleted
            ? `${t('Completed on')} ${moment(courseCompletedOn).format("DD-MMM-YYYY")}`
            : `${t('Expiring on')} ${moment(courseExpiryDate).format("DD-MMM-YYYY")}`;
    }

    return (
        <>
            {showComponent && (
                <Box style={{display: 'flex', marginTop: '10px'}}>
                    {isCompleted ? <GreenTick style={{height: '16px'}}/> : <ExpiringClock/>}
                </Box>
            )}
            <Box style={{display: 'flex', alignItems: 'center'}}>
                {showComponent && (
                    <span
                        className={`ribbon-text-expire ${isCompleted ? "certified-text" : ""}`}
                        style={{maxWidth: width, marginTop: '10px'}}
                    >
                        {expiryLabel}
                    </span>
                )}
            </Box>
        </>
    );
}

function FreeCourseAction({ testData, courseAdded, courseExpired, t, onViewCourse, onAddCourse }) {
    if (testData?.pricing !== "FREE") {
        return null;
    }

    if (testData?.isUserCourse) {
        return (
            <Box className='free-div'>
                <Box className="card-btn-new">
                    {courseExpired && !testData?.neverExpired ? (
                        <OverlayButton onClick={() => {}} title={t('VIEW_COURSE')} disabled />
                    ) : (
                        <OverlayButton onClick={onViewCourse} title={t('VIEW_COURSE')}/>
                    )}
                </Box>
            </Box>
        );
    }

    if (courseAdded) {
        return (
            <Box className='free-div'>
                <Box className="card-btn-new">
                    <OverlayButton onClick={onViewCourse} title={t('VIEW_COURSE')}/>
                </Box>
            </Box>
        );
    }

    return (
        <Box className='free-div'>
            <Box className="card-btn-new">
                <OverlayButton onClick={onAddCourse} title={t('ADD_COURSE')}/>
            </Box>
        </Box>
    );
}

/**
 * Test series card
 * @param props
 * @returns {*}
 * @constructor
 */
function CoursesCard(props) {
    const { testData, certificateListing, dueDateinDays, settingsData } = props;
    const history = useHistory();
    const t = useTranslations();
    const classes = useStyles();
    const [isModalVisible, setIsModalVisible] = useState(false);
    const location = useLocation();
    const showEvaluationTest = useSelector(state => state.filteredCourseList.showEvaluationTest) || location?.state?.showEvaluationTest;
    const showInstructions = useSelector(state => state.filteredCourseList.showInstructions) || location?.state?.showInstructions;
    const theme = useTheme();
    const [courseExpiryDate, setCourseExpiryDate] = useState('');
    const [showComponent, setShowComponent] = useState(false);
    const [certificateData, setCertificateData] = useState({})
    const [showExpirationDate, setShowExpirationDate] = useState(false);
    const user = useSelector((state) => state.user);
    const userId = user?.user?._id ? user?.user?._id : user?._id;
    const [courseAdded, setCourseAdded] = useState(false)
    const dispatch = useDispatch();
    const callRecentApi = async () => {
        const payload = { courseId: testData._id };
        await Promise.resolve(dispatch(recentCourseAction(payload)));
    };
    const openModal = () => {
        setIsModalVisible(true);
    };
    
    const closeModal = () => {
    setIsModalVisible(false);
    };


    function handleViewClick() {
        globalThis.dispatchEvent(new Event('storage'));
        reactGaEvent("Course Material", "View Course");
        callRecentApi();
        dispatch(setCourseName(testData?.name));
        dispatch(setCourseId(testData?._id));
        dispatch(setCourseProgress(testData?.progressPercent));
        history.push(`/course/${testData._id}`, {courseId:testData._id, subjectId: '', topicId:'', subjectDetail:testData, testData: '', subjectName:'', topicName:'', courseName: testData?.name, courseProgress: testData?.progressPercent, showEvaluationTest: showEvaluationTest, showInstructions: showInstructions, isCourseExpired: courseExpired});
    }

    const updateExpiration = (updatedTestData) => {
        const currentDate = new Date();
        const courseEndDate = updatedTestData?.assignedCourseEndDate
            ? new Date(updatedTestData.assignedCourseEndDate)
            : null;
    
        if (courseEndDate) {
            setCourseExpiryDate(courseEndDate);
            const timeDifference = courseEndDate.getTime() - currentDate.getTime();
            setExpireDays(Math.ceil(timeDifference / (1000 * 60 * 60 * 24)));
        } else {
            setExpireDays(null);
        }
    };
    

    function handleGoToTestClick() {
        const currentTime = Date.now();
        const tempDate = new Date(currentTime);
        tempDate.setDate(tempDate.getDate() + (dueDateinDays > 0 ? dueDateinDays - 1 : 0));
        tempDate.setHours(23, 59, 59, 999);
        const endDate = tempDate.getTime();

        dispatch(
            addCourse({
                userId,
                courses: [{
                    courseId: testData?._id,
                    startDate: currentTime,
                    dueDateinDays: user?.user?.userExpireInDay <= dueDateinDays ? Number.parseInt(user?.user?.userExpireInDay, 10) : dueDateinDays,
                    endDate
                }],
            })
        ).then(() => {
            const updatedTestData = { ...testData, assignedCourseEndDate: new Date(endDate), isUserCourse: true };
            updateExpiration(updatedTestData);
        });
    
        setCourseAdded(true);
        let data = {
            tag: "courseAddition",
            courseId: [testData?._id],
            scheduledDate: testData?.endDate,
        }
        dispatch(courseAddedNotification(userId, data));
        setShowExpirationDate(true);
        openModal();
    }
   
    const [expireDays, setExpireDays] = useState('');
    const [courseCompletedOn, setCourseCompletedOn] = useState('');
    const [courseExpired, setCourseExpired] = useState(false);
    const percentageCompletion = testData?.progressPercent ?? 0;

    useEffect(() => {
        checkExpiration();
    }, []);

    useEffect(() => {
        getCertificateListing();
    },[testData, certificateListing])

    useEffect(() => {
        if (testData) {
            updateExpiration(testData);
        }
    }, [testData]);

    const checkExpiration = () => {
        const currentDate = new Date();
    
        let courseEndDate = null;
        if (testData?.endDate) {
            courseEndDate = new Date(testData.endDate);
        } else if (testData?.assignedCourseEndDate) {
            courseEndDate = new Date(testData.assignedCourseEndDate);
        }

        if (testData.completedOnDate && testData.completedOnDate > 0) {
            let courseCompletedOn = new Date(testData.completedOnDate)
            setCourseCompletedOn(courseCompletedOn)
        }
        // Set course expiry date if available
        if (courseEndDate) {
            setCourseExpiryDate(courseEndDate);
            const timeDifference = courseEndDate.getTime() - currentDate.getTime();
            setExpireDays(Math.ceil(timeDifference / (1000 * 60 * 60 * 24)));
        } else {
            // If no end date is available, set expiration days to null
            setExpireDays(null);
        }
    };
   
    useEffect(() => {
        if (expireDays === null) {
            setCourseExpired(false);
        } else if (expireDays > 0) {
            setCourseExpired(false);
        } else {
            setCourseExpired(true);
        }
    }, [expireDays]);

    useEffect(() => {
        const timer = setTimeout(() => {
          setShowComponent(true);
        }, 300);
        return () => clearTimeout(timer);
    }, []);

    const getCertificateListing = () => {
        const matchedCertificate = certificateListing?.find(item => item?.courseId?._id === testData?._id);
        setCertificateData(matchedCertificate || {});
    }

    const courseImage = settingsData?.data?.[0]?.branding?.courseImage?.imagePath;
    const featuredImage = testData?.featured || courseImage || DefaultCourseImage;

    useEffect(() => {
        if(testData?.isUserCourse) {
            setShowExpirationDate(true);
        }
    },[testData?.isUserCourse])

    return (
        <React.Fragment>
        <Box className="card-list-image">
            <Box className='image-container image-fix'>
                <img style={{objectFit: 'contain', borderRadius: '4px 4px 0px 0px'}}
                    src={featuredImage}
                    alt="" onError={(e) => {
                        e.target.onerror = null;
                        e.target.src = DefaultCourseImage;
                    }} />
                {testData?.isUserCourse && <Box className={classes.courseBottomRight} style={{background: theme?.primaryColor}}>
                    <Box className="my-course-button">
                        <span className='ribbon-text' style={{color: theme?.primaryFontText}}>{t('MY_COURSE')}</span>
                    </Box>
                </Box>}
            </Box>

            <Box className='card-list'>
            <Box className="course-module">
                {testData.isSelfLearning === true ? <button className="course-learning" style={{border: `1px solid ${theme?.secondaryColor}`, color: theme?.secondaryColor}}>{t('SELF LEARNING')}</button> : ''}
                {testData.isLive === true ? <button className="course-live-learning" style={{border: `1px solid ${theme?.secondaryColor}`, color: theme?.secondaryColor}}><span className='live-image'><Live/></span><span>{t('live')}</span></button> : ''}
                <Box className="course-certificate-tag">
                    <Box>{certificateData?.courseId?._id === testData?._id 
                        ? <Box className='certified-card-tag'>
                                <CertifiedIcon/>
                                <Box className='certified-text'>{t('Certified')}</Box>
                            </Box> 
                        :
                        <Box style={{border: `1px solid ${theme?.secondaryColor}`, color: theme?.secondaryColor}} className='certificate-card-tag'>
                            {t('CERTIFICATE')}
                        </Box>}
                    </Box>
                </Box>
            </Box>
            <p className='card-title'>{testData.name}</p>
            <Box className='card-description' dangerouslySetInnerHTML={{ __html: testData?.description }}></Box>
            <Box className="course-bottom-right-expire">
                {showExpirationDate && testData?.isUserCourse ? <Box className="my-course-button-expire">
                    <ExpirationBadge
                        showComponent={showComponent}
                        expireDays={expireDays}
                        courseCompletedOn={courseCompletedOn}
                        certificateData={certificateData}
                        testData={testData}
                        courseExpiryDate={courseExpiryDate}
                        t={t}
                    />
                </Box> 
                : 
                <Box className="course-validity-text">
                    {t('Course validity')}: {testData?.dueDateinDays} {testData?.dueDateinDays > 1 ? t('days') : t('day')}</Box>
                }
                {settingsData?.data?.[0]?.gamification?.enabled && settingsData?.data?.[0]?.gamification?.pointsEnabled && <Box className="certificate-parent-box">
                    <Box className={`certificate-tag-align ${testData.isUserCourse === false ? 'extra-gap' : ''}`}>
                        <Box className='certificate-tag-points'><PointsIcon/></Box>
                        {testData.isUserCourse !== false && <Typography variant='inherit' className='card-point1'>{testData?.userAwardedPoint}/</Typography> }
                        <Typography variant='inherit' className='card-point2'>{testData?.courseTotalPoint}</Typography>
                    </Box>
                </Box>}
            </Box>

            <Box className='card-title-progress' style={{ minHeight: '26px' }}>
                {!testData.isAddedCourse && <LinearProgressWithLabel value={percentageCompletion} />}
            </Box>

            <FreeCourseAction
                testData={testData}
                courseAdded={courseAdded}
                courseExpired={courseExpired}
                t={t}
                onViewCourse={handleViewClick}
                onAddCourse={handleGoToTestClick}
            />

            </Box>
        </Box>
        {isModalVisible && (
            <EnrolledModal
                showModal={isModalVisible}
                closeModal={closeModal}
                classes={classes}
                t={t}
                testData={testData}
                history={history}
                showEvaluationTest={showEvaluationTest}
                showInstructions={showInstructions}
            />
        )}
        </React.Fragment>
    );
}

function LinearProgressWithLabel(props) {
    return (
        <Box display="flex" alignItems="center">
            <Box width="100%" mr={1}>
                <LinearProgress variant="determinate" value={props.value || 0} />
            </Box>
            <Box minWidth={35}>
                <Typography variant="body2" color="textSecondary">{`${Math.round(
                    props.value,
                )}%`}</Typography>
            </Box>
        </Box>
    );
}

LinearProgressWithLabel.propTypes = {
    value: PropTypes.number.isRequired,
};

EnrolledModal.propTypes = {
    showModal: PropTypes.bool,
    closeModal: PropTypes.func,
    classes: PropTypes.shape({
        modalBg: PropTypes.string,
        modalContent: PropTypes.string,
        modalContainer: PropTypes.string,
        successIcon: PropTypes.string,
        starVectorBox: PropTypes.string,
        starVector1: PropTypes.string,
        starVector2: PropTypes.string,
        starVector3: PropTypes.string,
        modalHeading: PropTypes.string,
        modalSubtext: PropTypes.string,
        okBtn: PropTypes.string,
        goToCoursesLink: PropTypes.string
    }).isRequired,
    t: PropTypes.func.isRequired,
    testData: PropTypes.shape({
        _id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
        name: PropTypes.string,
        progressPercent: PropTypes.number
    }),
    history: PropTypes.shape({
        push: PropTypes.func.isRequired
    }).isRequired,
    showEvaluationTest: PropTypes.bool,
    showInstructions: PropTypes.bool
};

ExpirationBadge.propTypes = {
    showComponent: PropTypes.bool,
    expireDays: PropTypes.number,
    courseCompletedOn: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
    certificateData: PropTypes.shape({
        courseId: PropTypes.shape({
            _id: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
        })
    }),
    testData: PropTypes.shape({
        _id: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
    }),
    courseExpiryDate: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
    t: PropTypes.func.isRequired
};

FreeCourseAction.propTypes = {
    testData: PropTypes.shape({
        pricing: PropTypes.string,
        isUserCourse: PropTypes.bool,
        neverExpired: PropTypes.bool
    }),
    courseAdded: PropTypes.bool,
    courseExpired: PropTypes.bool,
    t: PropTypes.func.isRequired,
    onViewCourse: PropTypes.func.isRequired,
    onAddCourse: PropTypes.func.isRequired
};

CoursesCard.propTypes = {
    testData: PropTypes.shape({
        _id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
        name: PropTypes.string,
        progressPercent: PropTypes.number,
        slug: PropTypes.string,
        endDate: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
        assignedCourseEndDate: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
        completedOnDate: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
        featured: PropTypes.string,
        description: PropTypes.string,
        isUserCourse: PropTypes.bool,
        isSelfLearning: PropTypes.bool,
        isLive: PropTypes.bool,
        pricing: PropTypes.string,
        dueDateinDays: PropTypes.number,
        neverExpired: PropTypes.bool,
        userAwardedPoint: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
        courseTotalPoint: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
        isAddedCourse: PropTypes.bool
    }).isRequired,
    certificateListing: PropTypes.arrayOf(
        PropTypes.shape({
            courseId: PropTypes.shape({
                _id: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
            })
        })
    ),
    dueDateinDays: PropTypes.number,
    settingsData: PropTypes.shape({
        data: PropTypes.arrayOf(
            PropTypes.shape({
                branding: PropTypes.shape({
                    courseImage: PropTypes.shape({
                        imagePath: PropTypes.string
                    })
                }),
                gamification: PropTypes.shape({
                    enabled: PropTypes.bool,
                    pointsEnabled: PropTypes.bool
                })
            })
        )
    })
};

CoursesCard.defaultProps = {
    certificateListing: [],
    dueDateinDays: 0,
    settingsData: {}
};

const useStyles = makeStyles(theme => ({
    modalBg: {
        position: 'fixed',
        top: 0,
        left: 0,
        width: '100%',
        height: '100% !important',
        background: 'rgba(0, 0, 0, 0.5)',
        justifyContent: 'center',
        alignItems: 'center',
        zIndex: '999999'
    },   
    courseBottomRight: {
        position: 'absolute',
        top: '17px',
        right: '-39px',
        textAlign: 'center',
        transform: 'rotate(45deg)',
        width: '139px',
        zIndex: '0'
    },
    modalContent: {
        backgroundColor: '#fff',
        position: 'absolute',
        top: "50%",
        left: "50%",
        transform: "translate(-50%, -50%)",
        padding: '16px',
        borderRadius: '25px',
        width: '450px',
        '@media (max-width:900px)': {
            width: '350px',
        },
        '@media (max-width:439px)': {
            width: '280px',
        }
    },
    modalContainer: {
        display:'flex',
        flexDirection:'column',
        alignItems:'center',
        justifyContent:'center',
        backgroundColor:'white',
        borderRadius: '25px',
        padding:'40px 50px',
        '@media (max-width:439px)': {
            padding:'30px',
        }
    },
    successIcon: {
        '@media (max-width:900px)': {
            width: '48px',
            height: '48px',
        },
        '@media (max-width:439px)': {
            width: '34px',
            height: '34px',
        }
    },
    modalHeading: {
        textAlign: 'center',
        fontWeight: 600,
        color: '#000000',
        fontSize: '20px',
        marginTop: '30px',
        '@media (max-width:900px)': {
            marginTop: '20px',
        },
        '@media (max-width:439px)': {
            fontSize: '14px',
            marginTop: '10px',
        }
    },
    modalSubtext: {
        textAlign: 'center',
        fontWeight: '400',
        color: '#374151',
        fontSize: '14px',
        marginTop: '20px',
        '@media (max-width:439px)': {
            fontSize: '11px',
            marginTop: '10px',
        }
    },
    okBtn: {
        fontWeight: "500",
        borderRadius: "8px",
        color: "#FFFFFF",
        cursor: "pointer",
        textTransform: 'capitalize',
        backgroundColor: "#0C3450",
        "&:hover": {
            backgroundColor: "#0C3450 !important",
        },
        fontSize: "12px",
        marginTop: '30px',
        padding: "10px 30px",
        '@media (max-width:900px)': {
            marginTop: '20px',
        },
        '@media (max-width:439px)': {
            fontSize: '11px',
            marginTop: '15px',
            padding: "8px 20px",
        }
    },
    goToCoursesLink: {
        color: '#0C3450',
        fontWeight: 600,
        fontSize: '12px',
        marginTop: '20px',
        '@media (max-width:439px)': {
            fontSize: '11px',
            marginTop: '10px',
        }
    },
    starVectorBox: {
        display: 'flex',
        position: 'fixed',
        top: '20px',
        right: '30px'
    },
    starVector1: {
        marginTop: '10px',
        zIndex: 1,
        marginRight: '-8px'
    },
    starVector2: {
        marginTop: "12px"
    },
    starVector3: {
        marginLeft: "10px"
    }
}));
export default CoursesCard;
